import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateFormData } from '../../../redux/slices/listingSlice'
import FormInput from '../../ui/FormInput'
import Dropdown from '../../ui/Dropdown'
import FormCheckbox from '../../ui/FormCheckbox'

const BasicInfoSection = () => {
  const dispatch = useDispatch()
  const formData = useSelector(state => state.listing.form.formData)
  const fieldErrors = useSelector(state => state.listing.form.fieldErrors)
  const isVirtualFashion = formData?.productType === 'virtual'
  const isOthersType = formData?.productType === 'others'
  const isDigitalService = isOthersType && formData?.isDigitalOnline
  const isLocalService = isOthersType && formData?.isLocalService

  // Ensure product type is always set to 'designer'
  useEffect(() => {
    if (!formData.productType || formData.productType !== 'designer') {
      dispatch(
        updateFormData({
          productType: 'designer'
        })
      )
    }
  }, [dispatch, formData.productType])

  // Debug what's coming from Redux
  useEffect(() => {
    console.log('BasicInfoSection - formData:', formData)
    console.log('BasicInfoSection - name field:', formData.name)
    console.log('BasicInfoSection - productType field:', formData.productType)
    console.log(
      'BasicInfoSection - isDigitalOnline field:',
      formData.isDigitalOnline
    )
    console.log(
      'BasicInfoSection - isLocalService field:',
      formData.isLocalService
    )
  }, [formData])

  const handleInputChange = e => {
    const { name, value, type } = e.target
    dispatch(
      updateFormData({
        [name]: type === 'number' ? Number(value) : value
      })
    )
  }

  const handleCheckboxChange = field => {
    // If toggling one service type on, turn the other off
    if (field === 'isDigitalOnline' && !formData[field]) {
      dispatch(
        updateFormData({
          [field]: true,
          isLocalService: false
        })
      )
    } else if (field === 'isLocalService' && !formData[field]) {
      dispatch(
        updateFormData({
          [field]: true,
          isDigitalOnline: false
        })
      )
    } else {
      dispatch(
        updateFormData({
          [field]: !formData[field]
        })
      )
    }
  }

  return (
    <div className='space-y-4 max-w-[1400px] mx-auto bg-white p-6 rounded-lg'>
      <h2 className='text-heading font-semibold text-gray-800 mb-4'>
        Basic Information
      </h2>

      <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
        <FormInput
          label='Name'
          name='name'
          type='text'
          value={formData?.name || ''}
          onChange={handleInputChange}
          error={fieldErrors?.name}
          required
          fluid={true}
          placeholder='Enter product name'
        />

        <div className='flex flex-col gap-2'>
          <FormInput
            as='select'
            label='Product Type'
            name='productType'
            value='designer'
            onChange={handleInputChange}
            error={fieldErrors?.productType}
            required
            disabled={true}
            options={[
              { value: 'designer', text: 'Original Design' },
              { value: 'sharing', text: 'Closet Sharing' },
              { value: 'virtual', text: 'Virtual Fashion' },
              { value: 'others', text: 'Others' }
            ]}
            placeholder='Select product type'
          />
          <p className='text-xs text-gray-600 italic mt-1'>
            Only original design is available at this time
          </p>

          {/* Digital/Online and Local Service checkboxes under product type dropdown */}
          {isOthersType && (
            <div className='mt-2 space-y-2'>
              <FormCheckbox
                label='This is digital/online'
                name='isDigitalOnline'
                checked={formData?.isDigitalOnline || false}
                onChange={() => handleCheckboxChange('isDigitalOnline')}
              />
              <FormCheckbox
                label='This is a local service'
                name='isLocalService'
                checked={formData?.isLocalService || false}
                onChange={() => handleCheckboxChange('isLocalService')}
              />
            </div>
          )}
        </div>
        <FormInput
          as='textarea'
          label='Description'
          name='description'
          value={formData?.description || ''}
          onChange={handleInputChange}
          error={fieldErrors?.description}
          required
          className='w-full'
          rows={4}
          placeholder='Enter product description'
        />
      </div>
    </div>
  )
}

export default BasicInfoSection
